import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M6.806 4.407a2.407 2.407 0 0 1-2.402 2.408A2.406 2.406 0 0 1 2 4.407 2.405 2.405 0 0 1 4.404 2a2.406 2.406 0 0 1 2.402 2.407m6.41 10.98c0-1.742.33-3.43 2.488-3.43 2.125 0 2.154 1.993 2.154 3.543v6.496h4.141V14.67c0-3.598-.775-6.364-4.972-6.364-2.016 0-3.368 1.107-3.921 2.157h-.056V8.637H9.074v13.36h4.142zM6.475 8.641H2.33V22h4.145z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }